<div class="panel-list-root">
        <div class="panel-list" >
            <div class="panel-list-item" *ngFor="let item of stepData; let index = index" (click)="selectTabName(item.name)" [class.active]="selectedName == item.name" [hidden]="item.showCondition == null? false: !item.showCondition()">
                <div  [ngClass]="selectedName==item.name?'item-selected':'none'" [@tabMovement]="{value:typeSelection, params:{offset:multiplyer}}"></div>
                <div>{{item.sideDesc|translateTA}}</div>
            </div>
        </div>
        <ng-container  *ngFor="let item of stepData">
            <div class="panel-list-item-wrapper-body" [hidden]="item.name!=selectedName" [@slideInOut]="{value:item.state, params:{offset:multiplyerBody}}" >
                <div  id="tab1" class="panel-list-item-body panel-elevated">
                    <div class="title-panel">
                        {{item.title|translateTA}}
                    </div>
                    <nz-divider class="panel-divider"></nz-divider>
                    <div class="info panel-elevated" *ngIf="item.info!=null">
                        {{item.info|translateTA}}
                    </div>
                    <nz-divider class="panel-divider"></nz-divider>
                    <ng-container
                        *ngIf="contentTemplateRef"
                        [ngTemplateOutlet]="contentTemplateRef"
                        [ngTemplateOutletContext]="{$implicit:item}"
                    ></ng-container>
                    <nz-divider class="panel-divider"></nz-divider>
                    <actions-buttons [buttonList]="item.buttonList"></actions-buttons>
                </div>
            </div>
        </ng-container>
    </div>
